import { createContext, useContext } from 'react';
import { createEventBus } from './event-bus';
// Create the context with the event bus
export const DropdownsContext = createContext({
    dropdownOpenedEB: createEventBus()
});
// Custom hook to use the dropdowns context
export const useDropdownsContext = () => useContext(DropdownsContext);
